import { create } from 'zustand';
import api from '../lib/api';

interface Resource {
    id: string;
    name: string;
    role: string;
    available_since: string;
    skills: string[];
    rate: string;
    status: string;
}

export interface ResourceUtilization {
    project_name: string;
    member_count: number;
}

export interface RoleCapacity {
    role: string;
    cap: number;
    dem: number;
}

interface ResourceState {
    bench: Resource[];
    utilization: ResourceUtilization[];
    capacity: RoleCapacity[];
    loading: boolean;
    error: string | null;
    fetchBench: () => Promise<void>;
    fetchUtilization: () => Promise<void>;
    fetchCapacity: () => Promise<void>;
}

export const useResourceStore = create<ResourceState>((set) => ({
    bench: [],
    utilization: [],
    capacity: [],
    loading: false,
    error: null,

    fetchBench: async () => {
        set({ loading: true, error: null });
        try {
            const response = await api.get('/work/resources/bench');
            set({ bench: response.data, loading: false });
        } catch (error: any) {
            set({ error: error.message, loading: false });
        }
    },
    
    fetchUtilization: async () => {
        set({ loading: true, error: null });
        try {
            const response = await api.get('/work/resources/utilization');
            set({ utilization: response.data, loading: false });
        } catch (error: any) {
            set({ error: error.message, loading: false });
        }
    },
    
    fetchCapacity: async () => {
        set({ loading: true, error: null });
        try {
            const response = await api.get('/work/resources/capacity');
            set({ capacity: response.data, loading: false });
        } catch (error: any) {
            set({ error: error.message, loading: false });
        }
    }
}));
